import { useEffect, useMemo } from "react";
import { setSeo } from "@/lib/seo";

/**
 * <SEO />: declarative wrapper around `setSeo`. Drop near the top of a
 * page component and it keeps `document.title`, meta tags, canonical
 * and JSON-LD in sync as props change.
 */
export default function SEO({
  title,
  description,
  canonical,
  robots,
  noindex = false,
  og,
  twitter,
  jsonLd,
}) {
  // Stringify nested objects so the effect dependencies are primitive
  // and React's exhaustive-deps lint stays happy.
  const ogKey      = useMemo(() => (og      ? JSON.stringify(og)      : ""), [og]);
  const twitterKey = useMemo(() => (twitter ? JSON.stringify(twitter) : ""), [twitter]);
  const jsonLdKey  = useMemo(() => (jsonLd  ? JSON.stringify(jsonLd)  : ""), [jsonLd]);

  useEffect(() => {
    setSeo({ title, description, canonical, robots, noindex, og, twitter, jsonLd });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, canonical, robots, noindex, ogKey, twitterKey, jsonLdKey]);

  return null;
}
